export default defineNuxtPlugin((nuxtApp) => {
  const {public: config} = useRuntimeConfig();
  nuxtApp.provide('publicEnv', config);
});
